<template>
  <div>
    <h2>Goals <span v-if="!loadingResources" class="count">({{ displayedGoals.length }})</span></h2>
    <SubjectFilter
      :subjects="filterOptions"
      :resource="resourceType"
      :page="pageType"/>
    <p v-if="displayedGoals.length === 0 && !shared" class="empty-notice"><router-link :to="{name: 'BrowseGoalsPage'}">Find some goals</router-link></p>
    <p v-if="filtering" class="text-muted"><i class="fa fa-circle-o-notch fa-spin"/>&nbsp;Loading goals...</p>
    <br>
    <div v-if="!filtering" class="row">
      <div
        class="col-md-12"
        v-for="goal in displayedGoals"
        :key="goal.uuid">
        <LibraryGoalCard
          :shared="shared"
          :student-name="goal.content_body.student_name"
          :goal="goal.content_body"
          :content-uuid="goal.content_uuid"
          :collection-uuid="goal.collection_uuid"/>
      </div>
    </div>
  </div>
</template>

<script>
import LibraryGoalCard from '@/components/library/LibraryGoalCard'
import SubjectFilter from '@/components/favorites/SubjectFilter'
import { mapState } from 'vuex'

export default {
  name: 'GoalsLibrary',
  components: {
    LibraryGoalCard,
    SubjectFilter
  },
  props: {
    goals: {
      type: Array,
      required: true
    },
    context: {
      type: String,
      default: ''
    },
    shared: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      resourceType: 'goals',
      pageType: 'library',
      filtering: false
    }
  },
  computed: {
    ...mapState('library', ['filters', 'loadingResources']),
    displayedGoals() {
      let goals = this.filterGoalsBySubject(this.goals, this.filters.goals) || []
      goals.sort((g1, g2) => {
        if (g1.created_at < g2.created_at) {
          return 1
        }
        if (g1.created_at > g2.created_at) {
          return -1
        }
        return 0
      })
      return goals
    },
    filterOptions() {
      var options = ['All Subjects']
      this.goals &&
        this.goals.forEach(goal => {
          const goalSubjectsToAdd = this.subjectsForGoal(goal).filter(s => !options.includes(s))
          if (goalSubjectsToAdd.length > 0) {
            options = options.concat(goalSubjectsToAdd)
          }
        })
      return options
    },
    allGoals() {
      return this.context === 'All Goals'
    }
  },
  methods: {
    filterGoalsBySubject(goals, subject) {
      this.filtering = true
      if (subject === 'All Subjects') {
        // I believe this setTimeout is to visually show the spinner to the user for a perceptible amount of time
        window.setTimeout(() => {
          this.filtering = false
        }, 300)

        // always return a new array to avoid mutability operations (e.g. sort)
        return [].concat(goals)
      }
      const filtered = goals.filter((goal) => {
        return this.subjectsForGoal(goal).includes(subject)
      })
      window.setTimeout(() => {
        this.filtering = false
      }, 300)
      return filtered
    },
    subjectsForGoal(goal) {
      let goalSubjects = [goal.content_body.subject]
      if (Array.isArray(goal.content_body.subject_alignments) && goal.content_body.subject_alignments.length > 0) {
        goalSubjects = goal.content_body.subject_alignments.map(sa => sa.subject)
      }
      return goalSubjects
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';
.count {
  color: @blue;
  font-weight: 300;
}
.empty-notice {
  font-size: 24px;
}
</style>
